import { ActionType, createReducer } from 'typesafe-actions';
import { UploadState, UploadTypes } from './types';
import uploadActions, { uploadReset } from './actions';

export const INITIAL_STATE: UploadState = {
  isLoading: false,
  error: 0,
  isSuccess: false,
  status: 'waiting',
};

export type RootUploadActions =
  | ActionType<typeof uploadActions>
  | ReturnType<typeof uploadReset>;

const uploadReducer = createReducer<UploadState, RootUploadActions>(
  INITIAL_STATE,
  {
    [UploadTypes.UploadRequest]: () => ({
      status: 'waiting',
      isLoading: true,
      error: 0,
      isSuccess: false,
    }),
    [UploadTypes.UploadSuccess]: () => ({
      status: 'uploaded',
      isLoading: false,
      error: 0,
      isSuccess: true,
    }),
    [UploadTypes.UploadFailure]: (state, action) => ({
      status: 'error',
      isLoading: false,
      error: action.payload,
      isSuccess: false,
    }),
    [UploadTypes.UploadReset]: (state) => ({
      ...state,
      error: 0,
      isLoading: false,
      isSuccess: false,
    }),
  }
);

export default uploadReducer;
